/**
 * Binom Advanced tab — peer of Standard / Campaign / Preview, shows Binom
 * Protect + Campaign settings + Notes. Reads draft from BinomDrawerContext.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { AlertCircle } from 'lucide-react';

import { LoadingSpinner } from '@/components/ui/feedback/LoadingSpinner';

import { useBinomDrawer } from './standard/binom/BinomDrawerContext';
import { BinomAdvancedConfigTab } from './standard/binom/sections/advanced';

const BinomAdvancedTab: FC = () => {
  const drawer = useBinomDrawer();
  if (drawer.isLoading || drawer.campaignLoading) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center py-12">
        <LoadingSpinner />
      </div>
    );
  }
  if (drawer.isError || !drawer.draft) {
    return (
      <div className="flex min-h-0 flex-1 items-center">
        <div className="flex w-full items-center gap-2 rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm text-destructive">
          <AlertCircle className="h-4 w-4 shrink-0" aria-hidden />
          <span>
            Failed to load Binom campaign. {drawer.errorMessage ?? ''}
          </span>
        </div>
      </div>
    );
  }
  return (
    <BinomAdvancedConfigTab
      draft={drawer.draft}
      patchCampaignMeta={drawer.patchCampaignMeta}
      campaignId={drawer.campaignId}
    />
  );
};

export default BinomAdvancedTab;
